import styled, { css } from 'styled-components';

import { defaultThemeProp, StyledEmptyState } from '@pega/cosmos-react-core';

export const StyledIconList = styled.ul`
  overflow-x: hidden;
  overflow-y: auto;
  list-style: none;
  height: 100%;

  ${StyledEmptyState} {
    width: 100%;
    height: 100%;
  }
`;

export const StyledIconListItem = styled.li(
  ({ theme }) => css`
    padding: calc(2 * ${theme.base.spacing});
    border-bottom: 0.0625rem solid ${theme.base.palette['border-line']};
    width: 20%;
  `
);

StyledIconListItem.defaultProps = defaultThemeProp;

export const StyledProgressContainer = styled.li`
  position: relative;
  height: 2.8rem;
  width: 100%;
`;
